import {
    SendsPageItemType,
    SendsPagesUpdateType,
    updateSendsPage, updateSendsPageActiveStatus,
    useChangeSendsStatus,
    useSendsPage, useUpdateSendsData
} from "@twigsby/client-data";
import {
    PageHeader,
    Button,
    ColourSolid, ContentBlock, ContentLoader,
    DropdownMenu, FullWidthSidebar,
    ItemMenuEntry, ToggleSwitch,
    ToggleType,
    useLayout, useNotifications
} from "@twigsby/frontend-framework";
import {ParseURL} from "@twigsby/helpers";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useNavigate, useParams} from "react-router-dom";
import CreateStandaloneSendForm from "../../Components/SendsAdmin/CreateSendsForm";
import SendsNavigation from "../../Components/SendMail/Shared/Controls/SendsNavigation";
import {faClipboard} from "@fortawesome/pro-solid-svg-icons/faClipboard";
import {faCopy} from "@fortawesome/pro-solid-svg-icons/faCopy";
import {faEllipsisVertical} from "@fortawesome/pro-solid-svg-icons/faEllipsisVertical";
import {faExternalLink} from "@fortawesome/pro-solid-svg-icons/faExternalLink";
import {faPencil} from "@fortawesome/pro-solid-svg-icons/faPencil";
import {faRectangleHistory} from "@fortawesome/pro-solid-svg-icons/faRectangleHistory";
import {faTrash} from "@fortawesome/pro-solid-svg-icons/faTrash";
import {faWavePulse} from "@fortawesome/pro-solid-svg-icons/faWavePulse";
import PageHistoryModal from "../../Components/SendsAdmin/Modals/PageHistoryModal";
import SendMailHistoryProvider from "../../Providers/SendMailHistoryProvider";
import ConfirmDeleteSendsPageModal from "../../Components/SendsAdmin/Modals/ConfirmDeleteSendsPageModal";
import {useSite} from "../../Providers/SiteInterfaceProvider";

const EditSendsPage = () => {
    const { t } = useTranslation();
    const { isMedium, isLarge, isXL } = useLayout();
    const { currentLocale, updatePageMeta } = useSite();

    const navigate = useNavigate();

    const { pageId } = useParams();
    const { addNotification } = useNotifications();
    const { data, status, error } : any = useSendsPage(parseInt(pageId as string));

    const [ activeSendsPage, setActiveSendsPage ] = useState<any>({ isOpen: false, pageData: null});

    const [ pageHistoryOpen, setPageHistoryOpen ] = useState<boolean>(false);

    const [ savingData, setSavingData ] = useState<boolean>(false);
    const [ saveError, setSaveError ] = useState<any>();

    const updateSendsStatus = useChangeSendsStatus();
    const sendsTemplates = useUpdateSendsData();

    const sendsEditRef = useRef<any>();
    const sendMailNavigationRef = useRef<any>();

    const HandleSave = async (newData: SendsPageItemType, e :any) => {
        setSavingData(true);

        newData.isActive = data.isActive;

        await updateSendsPage(parseInt(pageId as string), newData)
            .then((resp: any) => {
                sendsTemplates.mutate({
                    updateType: SendsPagesUpdateType.UPDATE,
                    newData: {...data, ...newData }
                });

                addNotification({
                    title: t('results.sendsUpdated'),
                    icon: faPencil,
                    colour: ColourSolid.Success
                });

            })
            .catch((e: any) => {
                setSaveError(e.response.data);
            })
            .finally(() => setSavingData(false));
    }

    const HandleTemplateStatus = async (pageId: number, active: any) => {
        await updateSendsPageActiveStatus(pageId, active).then((resp) => {
            updateSendsStatus.mutate({
                newData: active,
                id: pageId,
            })
        })
    }

    const ShowDeleteConfirmation = (page: SendsPageItemType) => {
        setActiveSendsPage({ pageData: page, isOpen: true })
    }

    const HandleOpen = async (slug: string) => {
        window.open(ParseURL(slug), '_blank');
    }

    const HandleCopyUrl = async (slug: string) => {
        addNotification({
            title: t('results.copiedClipboard'),
            icon: faClipboard
        });
        await navigator.clipboard.writeText(ParseURL(slug));
    }

    const PageActions = () => {
        return (
            <div className={'flex-row flex-gap-sm ml-a'} style={{width: 'auto'}} >
                <Button onClick={(e) => [e.preventDefault(), setPageHistoryOpen(true)]} colour={ColourSolid.Secondary} title={t('actions.history')} iconOnly={!isXL} icon={faRectangleHistory} squared={true} />
                <Button onClick={(e) => [e.preventDefault(), HandleOpen(data.liveUrl ? data.liveUrl : '')]} colour={ColourSolid.Secondary} title={t('actions.open')} iconOnly={!isXL} icon={faExternalLink} squared={true} />
                <Button onClick={(e) => [e.preventDefault(), HandleCopyUrl(data.liveUrl ? data.liveUrl : '')]} colour={ColourSolid.Secondary} title={t('actions.copyUrl')} iconOnly={!isXL} icon={faCopy} squared={true} />

                <Button
                    onClick={(e) => [e.preventDefault(), HandleTemplateStatus(data.id ? data.id : -1, !data?.isActive)]}
                    colour={ColourSolid.Secondary}
                    title={t('status.active')}
                    iconOnly={!isXL}
                    icon={faWavePulse}
                    squared={true}
                    addon={<ToggleSwitch extraClass={'ml-md'} hideLabel={true} type={ToggleType.Switch} label={data?.isActive ? t('actions.disable') : t('actions.makeActive')} name={'pageActive'} defaultChecked={data?.isActive} />}
                />
                <Button onClick={(e) => [e.preventDefault(), ShowDeleteConfirmation(data)]} colour={ColourSolid.Alert} title={t('actions.delete')} iconOnly={!isXL} icon={faTrash} squared={true} />

                {/*
                <div onClick={(e) => e.stopPropagation()}>
                    <ToggleSwitch type={ToggleType.Switch} hideLabel={true} name={`sendsPageEntry${pageId}`} label={'Active'} checked={data.isActive} onChange={(e: any) => HandleTemplateStatus(data.id ? data.id : -1, e.currentTarget.checked)} />
                </div>*/}
            </div>
        )
    }

    useEffect(() => {
        updatePageMeta({
            title: t('status.editing', { item : data?.title })
        });
    }, [currentLocale]);

    return  (
        <SendMailHistoryProvider pageId={parseInt(pageId as string)}>
            <FullWidthSidebar
                ref={sendsEditRef}
                navigationComponent={
                    <SendsNavigation
                        title={t('status.editing', { item : data?.title })}
                        ref={sendMailNavigationRef}
                        addonContent={
                            <div className={'section-navigation-header-collapsed-addon'}>
                                {isMedium && !isLarge &&  (
                                    <PageActions />
                                )}

                                {!isMedium && (
                                    <>
                                        <DropdownMenu
                                            trigger={
                                                <Button
                                                    squared={true}
                                                    title={t('actions.title')}
                                                    extraClass={'edit-page-menu'}
                                                    showArrow={isMedium}
                                                    icon={faEllipsisVertical}
                                                    iconOnly={!isMedium}
                                                />
                                            }
                                        >

                                            <ItemMenuEntry
                                                title={t('actions.history')}
                                                onClick={() => setPageHistoryOpen(true)}
                                                icon={faRectangleHistory}
                                            />

                                            <ItemMenuEntry
                                                title={t('divider')}
                                                sectionDivider={true}
                                            />

                                            <ItemMenuEntry
                                                title={t('actions.open')}
                                                onClick={() => HandleOpen(data.liveUrl ? data.liveUrl : '')}
                                                icon={faExternalLink}
                                            />

                                            <ItemMenuEntry
                                                title={t('actions.copyUrl')}
                                                onClick={() => HandleCopyUrl(data.liveUrl ? data.liveUrl : '')}
                                                icon={faCopy}
                                            />

                                            <ItemMenuEntry
                                                title={t('divider')}
                                                sectionDivider={true}
                                            />

                                            <ItemMenuEntry
                                                title={t('status.active')}
                                                onClick={() => HandleTemplateStatus(data.id ? data.id : -1, !data?.isActive)}
                                                icon={faWavePulse}
                                                addonContent={<ToggleSwitch hideLabel={true} type={ToggleType.Switch} label={data?.isActive ? t('actions.disable') : t('actions.makeActive')} name={'pageActive'} defaultChecked={data?.isActive} />}

                                            />

                                            <ItemMenuEntry
                                                title={t('actions.delete')}
                                                onClick={() => ShowDeleteConfirmation(data)}
                                                icon={faTrash}
                                            />

                                        </DropdownMenu>
                                    </>
                                )}
                            </div>
                        }
                    />
                }
                extraContentClass={`flex-column `}
            >
                {isLarge && (
                    <PageHeader title={t('status.editing', { item: data?.title })}>
                        <PageActions />
                    </PageHeader>
                )}

                <div className={'pt-xl pb-xl p-md'}>
                    {status === "loading" ? (
                        <ContentLoader />
                    ) : status === "error" ? (
                        <ContentBlock error={true} title={error.name} content={error.message} />
                    ) : (
                        <div className={'row mb-xxxl'}>
                            <div className={'col-xs-12 col-xl-6 col-xxl-5 '}>
                                <CreateStandaloneSendForm
                                    saveCallback={HandleSave}
                                    existingData={data}
                                    savingData={savingData}
                                    error={saveError}
                                />
                            </div>
                        </div>
                    )}

                    <PageHistoryModal pageId={parseInt(pageId as string)} isOpen={pageHistoryOpen} closeCallback={() => setPageHistoryOpen(false)} />
                </div>

                <ConfirmDeleteSendsPageModal
                    pageData={data}
                    isOpen={activeSendsPage.isOpen}
                    closeCallback={() => setActiveSendsPage({...activeSendsPage, isOpen: false})}
                    actionedCallback={() => navigate('/')}
                />

            </FullWidthSidebar>
        </SendMailHistoryProvider>
    )
}

export default EditSendsPage
